<template>
  <div id="app">
    <AppHeader />
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
      <router-view />
      </fade-transition>
    </main>
    <AppFooter />
  </div>
</template>
<script>
import { FadeTransition } from 'vue2-transitions'
import AppFooter from '@/layout/AppFooter'
import AppHeader from '@/layout/AppHeader'

export default {
  name: 'home',
  components: {
    FadeTransition,
    AppFooter,
    AppHeader
  }
}
</script>
